<template>
  <div class="create-list">
    <div class="create_new_list_overlay" v-if="showCreateList"></div>
    <div class="create__new__list" v-if="showCreateList">
      <div class="create__list__name flex-c">
        <span>Create New List</span>
      </div>
      <div class="create-section">
        <div class="create__list__input">
          <input
            type="text"
            v-model.trim="newListName"
            placeholder="List name"
            ref="createListInput"
            :class="{
              'is-invalid': listNameErr
            }"
            v-on:keypress="triggerCreateList"
          />
          <div class="err__msg">
            <span v-if="listNameErr">List name is required.</span>
            <span v-if="listErrMsg">List name is already exists.</span>
          </div>
        </div>
        <div class="button-group">
          <div class="create__btn">
            <V-Button
              :loading="loader"
              :type="'button'"
              :text="'Create'"
              :callback="createList"
            />
          </div>
          <div class="cancel__btn">
            <V-Button
              :type="'button'"
              :text="'Cancel'"
              :callback="cancelList"
              :disableBtn="loader"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="list-wrap-btn-section">
      <div class="list-dropdown">
        <div class="add__list" @click="showList = !showList">
          <label class="list-label" for="listDropdown">List</label>
          <input
            id="listDropdown"
            type="text"
            v-model="getSelectedList"
            disabled
          />
        </div>
        <div class="dropdown__list" v-if="showList">
          <div @click="showNewList" class="create__list__btn">
            Create New List
          </div>
          <div class="list__border">
            <ul class="list__data__section" v-if="listJson.length > 0">
              <li
                v-for="(ele, index) in listJson"
                :key="index"
                @click="
                  setSelectedListInfo(ele)
                  showList = !showList
                "
                :class="{ 'is-select': getSelectedList === ele.name }"
              >
                {{ ele.name }}
              </li>
            </ul>
          </div>

          <span class="sharp__pointer"></span>
        </div>
      </div>
      <div class="list-add-btn" v-if="listType !== 'bulk'">
        <div v-if="showAddListBtn">
          <button @click="addToList" v-if="!bulkLoader">Add</button>
          <Spinner v-else />
        </div>
        <div v-else>
          <button @click="redirectCustomList">View List</button>
        </div>
      </div>
    </div>
    <div class="overlay" v-if="showList" @click="showList = false"></div>
  </div>
</template>

<script>
import Button from '@/components/Button'
import sharedFunction from './../assets/util/functions.js'
import { get, post } from './../assets/util/rest.js'
import { setTimeout } from 'timers'
import { MxEvent, HttpUrl } from './../assets/util/constants/analytics.js'
import Spinner from '@/components/Spinner'
import {
  TRIGGERS_TRACK_TO_LB,
  myLeadsUrl
} from '../assets/util/constants/constants.js'

export default {
  name: 'Create-List',
  props: ['contactId', 'listType', 'showActivationPopup'],
  data: function() {
    return {
      showList: false,
      newListName: '',
      listJson: [],
      loader: false,
      showCreateList: false,
      listNameErr: false,
      listErrMsg: false,
      bulkLoader: false,
      showAddListBtn: true
    }
  },
  components: {
    'V-Button': Button,
    Spinner
  },
  computed: {
    getSelectedList() {
      return this.$store.state.linkedin.list.selectedList
    },
    getSelectedListId() {
      return this.$store.state.linkedin.list.selectedListId
    },
    isAccountVerified: function() {
      return this.$store.state.header.emailStatus == 0
    }
  },
  methods: {
    setSelectedListInfo(ele) {
      const { name: listName, id: listId } = ele
      console.log('listName ', listName)
      this.$store.state.linkedin.list.selectedList = listName
      this.$store.state.linkedin.list.selectedListId = listId
      localStorage.setItem('AP_SELECTED_LIST', listName)
      localStorage.setItem('AP_SELECTED_LIST_ID', listId)
      this.showAddListBtn = true
      const dataMap = {
        pageType: this.listType,
        status: 'Changed'
      }
      sharedFunction.track(MxEvent.addToList, dataMap, this.$store.state)
    },
    showNewList() {
      if (!this.isAccountVerified) {
        this.showList = false
        this.showActivationPopup()
      } else {
        this.showCreateList = true
        this.$nextTick(() => this.$refs.createListInput.focus())
      }
    },
    backToList() {
      this.showCreateList = false
      this.newListName = ''
    },
    createList() {
      this.loader = true
      const data = { listName: this.newListName }
      if (this.newListName.length > 1) {
        post(HttpUrl.createList, data).then(response => {
          response.json().then(res => {
            if (res.result == 'success') {
              this.setSelectedListInfo(res)
              this.fetchAllLists()
              this.showList = false
              this.backToList()
              this.loader = false
              const dataMap = {
                pageType: this.listType,
                status: 'Created'
              }
              sharedFunction.track(
                MxEvent.addToList,
                dataMap,
                this.$store.state
              )
              sharedFunction.showNotificationMsg(
                `List ${data.listName} created`,
                2000
              )
            } else if (res.result == 'exists') {
              this.listErrMsg = true
              this.loader = false
              setTimeout(() => (this.listErrMsg = false), 1500)
            }
          })
        })
      } else {
        this.loader = false
        this.listNameErr = true
        setTimeout(() => (this.listNameErr = false), 1500)
      }
    },
    triggerCreateList(event) {
      if (event.keyCode === 13) {
        event.preventDefault()
        this.createList()
      }
    },
    cancelList() {
      this.backToList()
    },
    deleteList() {
      console.log('Delete List')
    },
    editList() {
      console.log('Edit List')
    },
    fetchAllLists() {
      get(HttpUrl.fetchAllList).then(response => {
        response.json().then(res => {
          this.listJson = res
        })
      })
    },
    addToList() {
      if (!this.isAccountVerified) {
        this.showActivationPopup()
      } else {
        this.bulkLoader = true
        const listName = this.$store.state.linkedin.list.selectedList
        const data = {
          contactIds: this.contactId,
          listName,
          sn: this.$store.state.isSalesNavigator
        }
        post(HttpUrl.addContactToListV2, data)
          .then(response => {
            this.bulkLoader = false
            switch (response.status) {
              case 200:
                this.showAddListBtn = false
                response.json().then(() => {
                  sharedFunction.showNotificationMsg(
                    `Successfully added to ${listName}`,
                    2000
                  )
                })
                sharedFunction.track(
                  MxEvent.addToList,
                  { pageType: this.listType, status: 'Added' },
                  this.$store.state
                )
                break
              default:
                this.bulkLoader = false
                sharedFunction.showNotificationMsg(
                  'Failed! Try again ...',
                  2000
                )
                sharedFunction.track(
                  MxEvent.addToList,
                  { pageType: this.listType, status: 'Failed' },
                  this.$store.state
                )
                break
            }
          })
          .catch(e => {
            console.log('error :' + e)
          })
      }
    },
    redirectCustomList() {
      if (!this.isAccountVerified) {
        this.showActivationPopup()
      } else {
        sharedFunction.track(
          MxEvent.addToList,
          { pageType: this.listType, status: 'Redirect Myleads' },
          this.$store.state
        )
        window.open(
          myLeadsUrl(
            this.$store.state.linkedin.list.selectedListId,
            TRIGGERS_TRACK_TO_LB.VIEW_LIST
          )
        )
      }
    }
  },
  created() {
    this.fetchAllLists()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.create-list {
  position: relative;

  .create_new_list_overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(102, 112, 128, 0.2);
    z-index: 11;
  }
  .create__new__list {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 85%;
    padding: 20px 15px;
    z-index: 12;
    background: #fff;
    border: 1px solid rgba(102, 112, 128, 0.2);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    .create__list__name {
      span {
        line-height: 24px;
      }
    }
    .create-section::v-deep {
      padding-top: 15px;

      .create__list__input {
        height: 54px;
        input {
          width: 100%;
          padding: 7px 0;
          border: none;
          border: 1px solid #e0e4ea;
          border-radius: 6px;
          padding: 8px 16px;
          outline: none;
          color: $text-dark;
          &::placeholder {
            color: #ccc;
          }
          &.is-invalid {
            border-bottom: 1px solid red;
          }
          &.is-valid {
            border-bottom: 1px solid green;
          }
        }
        .err__msg {
          font-size: 11px;
          color: red;
        }
      }
      button {
        width: 100%;
        padding: 7px 0;
        font-weight: 500;
        letter-spacing: 0.3px;
        text-transform: capitalize;
        border-radius: 2px;
        outline: none;
        height: 30px;
      }
      .button-group {
        display: flex;
        gap: 10px;
      }
      .create__btn {
        transition: all 0.2s ease;
        width: 50%;
        button {
          height: 36px;
          border-radius: 6px;
          color: $white;
          border: 1px solid $primary-color;
          background: $primary-color;
          font-size: 12px;
          &:hover {
            background: lighten($primary-color, 5%);
          }
        }
      }
      .cancel__btn {
        transition: all 0.2s ease;
        width: 50%;
        button {
          height: 36px;
          border-radius: 6px;
          color: $primary-color;
          border: 1px solid rgba(102, 112, 128, 0.2);
          color: #667080;
          font-size: 13px;
          background: $white;
          &:hover {
            color: $primary-color;
            border: 1px solid $primary-color;
          }
        }
      }
      .spinner {
        margin: 0 auto;
        height: 30px;
        margin-bottom: 10px;
      }
    }
  }
  .list-wrap-btn-section {
    display: flex;
    align-items: center;
    gap: 15px;
    .list-dropdown {
      flex-grow: 1;
      position: relative;
    }
    .add__list {
      width: 100%;
      position: relative;
      border: 1px solid rgba(102, 112, 128, 0.2);
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      margin-right: 5px;

      .list-label {
        position: absolute;
        left: 8px;
        top: -7px;
        padding: 0 4px;
        background: #fff;
        font-size: 11px;
        letter-spacing: 0.3px;
      }
      input {
        width: 100%;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        border: none;
        outline: none;
        padding: 9px 20px 9px 15px;
        background: transparent;
        font-size: 14px;
        cursor: pointer;
        color: #667080;
      }
      &::after {
        content: '\e313';
        font-family: 'Material Icons';
        font-size: 16px;
        color: #444;
        position: absolute;
        right: 7px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .list-add-btn {
      button {
        border-radius: 6px;
        padding: 9px 10px;
        border: none;
        background: $primary-color;
        color: $white;
        box-shadow: 0 0 0 0 $primary-color;
        width: 80px;
      }
    }
  }
  .overlay {
    position: fixed;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    background: transparent;
  }
  .dropdown__list {
    position: absolute;
    color: $text-dark;
    width: 100%;
    top: 35px;
    border: 1px solid #eee;
    font-size: 14px;
    background: $white;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
    border-radius: 8px;
    z-index: 10;
    .list__border {
      border-top: 1px solid #eee;
      .list__data__section {
        margin: 0;
        padding: 0;
        max-height: 156px;
        overflow: hidden;
        overflow-y: auto;
        &::-webkit-scrollbar-track {
          background-color: #eee;
          border-radius: 4px;
        }
        &::-webkit-scrollbar {
          width: 0.4em;
          height: 0.4em;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #bbb;
          outline: 1px solid slategrey;
          border-radius: 4px;
        }
        &::-webkit-scrollbar,
        ::-webkit-scrollbar-thumb {
          overflow: visible;
          border-radius: 4px;
        }
        li {
          font-size: 14px;
          line-height: 20px;
          color: #667080;
          padding: 8px 16px;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          display: block;
          text-overflow: ellipsis;
          &:hover {
            background: rgba(102, 112, 128, 0.03);
          }
          &.is-select {
            font-weight: bold;
          }
        }
      }
    }
    .create__list__btn {
      cursor: pointer;
      text-align: left;
      padding: 8px 15px;
      color: $primary-color;
      &:hover {
        background: #f4f6ff;
      }
    }

    .sharp__pointer {
      padding: 5px;
      display: block;
      position: absolute;
      top: -6px;
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
      transform: rotate(45deg);
      background: $white;
      left: 25px;
      border-top-left-radius: 3px;
    }
  }
}
</style>
